import React, { useEffect, useRef } from 'react';

export default function ChatThread({ messages, isTyping, typingLabel = null }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]);

  return (
    <div className="chat-thread">
      {messages.map((msg, idx) => (
        // Prefer a stable id when present; fall back to idx only for
        // legacy messages that predate id-tracking. Welcome bubbles
        // (msg.eliza === true) render with the SAME markup and styling
        // as every other assistant message — they're flagged only so
        // the dedupe layer can key them per session_id.
        <div key={msg.id || idx} className={`chat-message ${msg.role}`}>
          <div className="message-bubble">{msg.content}</div>
        </div>
      ))}
      {isTyping && (
        <div className="chat-message assistant">
          <div className="message-bubble typing-indicator">
            <span /><span /><span />
          </div>
          {typingLabel && (
            <div className="typing-label">{typingLabel}</div>
          )}
        </div>
      )}
      <div ref={bottomRef} />
    </div>
  );
}
